// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export class DataBuffer {
    constructor(bytes) {
        this.data = [];
        this.offset = 0;
        if (bytes && bytes !== null) {
            this.data = bytes;
        }
    }
    // установить позицию чтения в начало
    Reset() {
        this.offset = 0;
    }
    EndOfBuffer() {
        // getter
        return this.offset >= this.data.length;
    }
    Length() {
        // getter
        return this.data.length;
    }
    ReadDouble() {
        const buffer = new ArrayBuffer(8);
        const dv = new DataView(buffer);
        for (let i = 0; i < 8; i++) {
            dv.setUint8(i, this.data[this.offset++]);
        }
        return dv.getFloat64(0);
    }
    ReadDate() {
        const ticks = this.ReadInt64();
        return new Date(ticks);
    }
    ReadSingle() {
        const buffer = new ArrayBuffer(4);
        const dv = new DataView(buffer);
        for (let i = 0; i < 4; i++) {
            dv.setUint8(i, this.data[this.offset++]);
        }
        return dv.getFloat32(0);
    }
    ReadInt32() {
        const buffer = new ArrayBuffer(4);
        const dv = new DataView(buffer);
        for (let i = 0; i < 4; i++) {
            dv.setUint8(i, this.data[this.offset++]);
        }
        return dv.getInt32(0);
    }
    ReadInt64() {
        const buffer = new ArrayBuffer(8);
        const dv = new DataView(buffer);
        for (let i = 0; i < 8; i++) {
            dv.setUint8(i, this.data[this.offset++]);
        }
        const hi = dv.getInt32(0);
        const lo = dv.getUint32(4);
        return hi * 4294967296 + lo;
    }
    ReadString() {
        let length = this.ReadShort();
        if (length < 0) // #112428
         {
            length += 65536;
        } // 32768 * 2
        const readTo = this.offset + length;
        let string = '';
        while (this.offset < readTo) {
            let byte1 = this.data[this.offset++];
            // значения были отрицательными, поэтому символы парсились неправильно
            if (byte1 < 0) {
                byte1 = byte1 + 256;
            }
            if (byte1 < 0x80) {
                string += String.fromCharCode(byte1);
            }
            else if (byte1 >= 0xc2 && byte1 < 0xe0) {
                const byte2 = this.data[this.offset++];
                string += String.fromCharCode(((byte1 & 0x1f) << 6) + (byte2 & 0x3f));
            }
            else if (byte1 >= 0xe0 && byte1 < 0xf0) {
                const byte2 = this.data[this.offset++];
                const byte3 = this.data[this.offset++];
                string += String.fromCharCode(((byte1 & 0xff) << 12) + ((byte2 & 0x3f) << 6) + (byte3 & 0x3f));
            }
            else if (byte1 >= 0xf0 && byte1 < 0xf5) {
                const byte2 = this.data[this.offset++];
                const byte3 = this.data[this.offset++];
                const byte4 = this.data[this.offset++];
                let codepoint = ((byte1 & 0x07) << 18) + ((byte2 & 0x3f) << 12) + ((byte3 & 0x3f) << 6) + (byte4 & 0x3f);
                codepoint -= 0x10000;
                string += String.fromCharCode((codepoint >> 10) + 0xd800, (codepoint & 0x3ff) + 0xdc00);
            }
        }
        return string;
    }
    ReadByte() {
        let byte0 = this.data[this.offset++];
        if (byte0 < 0) {
            byte0 = byte0 + 256;
        }
        return byte0;
    }
    ReadShort() {
        const buffer = new ArrayBuffer(2);
        const dv = new DataView(buffer);
        dv.setUint8(0, this.data[this.offset++]);
        dv.setUint8(1, this.data[this.offset++]);
        return dv.getInt16(0);
    }
    ReadBuffer(length) {
        const buffer = [];
        if (length === 0) {
            return new DataBuffer(buffer);
        }
        if (!length || length === null) {
            console.log('Really Nigga ???');
            length = this.data.length - this.offset;
        }
        for (let i = 0; i < length; i++) {
            buffer.push(this.data[this.offset++]);
        }
        return new DataBuffer(buffer);
    }
    ReadAllBytes() {
        const buffer = [];
        while (!this.EndOfBuffer()) {
            buffer.push(this.data[this.offset++]);
        }
        return buffer;
    }
    ReadBoolean() {
        return this.data[this.offset++] === 1;
    }
    WriteDouble(value) {
        const buffer = new ArrayBuffer(8);
        const dv = new DataView(buffer);
        dv.setFloat64(0, value);
        for (let i = 0; i < 8; i++) {
            this.data.push(dv.getUint8(i));
        }
    }
    WriteDate(value) {
        const ticks = value.valueOf();
        this.WriteInt64(ticks);
    }
    WriteSingle(value) {
        const buffer = new ArrayBuffer(4);
        const dv = new DataView(buffer);
        dv.setFloat32(0, value);
        for (let i = 0; i < 4; i++) {
            this.data.push(dv.getUint8(i));
        }
    }
    WriteInt32(value) {
        const buffer = new ArrayBuffer(4);
        const dv = new DataView(buffer);
        dv.setInt32(0, value);
        for (let i = 0; i < 4; i++) {
            this.data.push(dv.getUint8(i));
        }
    }
    WriteInt64(value) {
        const buffer = new ArrayBuffer(8);
        const dv = new DataView(buffer);
        dv.setBigInt64(0, BigInt(value));
        for (let i = 0; i < 8; i++) {
            this.data.push(dv.getUint8(i));
        }
    }
    WriteString(value) {
        // резервируем место под длину, ее саму запишем позже
        const lengthIndex = this.data.length;
        this.WriteShort(0);
        const length = value.length;
        for (let i = 0; i < length; i++) {
            let charcode = value.charCodeAt(i);
            if (charcode < 0x80) {
                this.data.push(charcode);
            }
            else if (charcode < 0x800) {
                this.data.push(0xc0 | (charcode >> 6), 0x80 | (charcode & 0x3f));
            }
            else if (charcode < 0xd800 || charcode >= 0xe000) {
                this.data.push(0xe0 | (charcode >> 12), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f));
            }
            else {
                i++;
                charcode = 0x10000 + (((charcode & 0x3ff) << 10) | (value.charCodeAt(i) & 0x3ff));
                this.data.push(0xf0 | (charcode >> 18), 0x80 | ((charcode >> 12) & 0x3f), 0x80 | ((charcode >> 6) & 0x3f), 0x80 | (charcode & 0x3f));
            }
        }
        // записываю длину в нужное место
        const buffer = new ArrayBuffer(2);
        const dv = new DataView(buffer);
        dv.setInt16(0, this.data.length - lengthIndex - 2);
        this.data[lengthIndex] = dv.getUint8(0);
        this.data[lengthIndex + 1] = dv.getUint8(1);
    }
    WriteByte(value) {
        this.data.push(value);
    }
    WriteShort(value) {
        const buffer = new ArrayBuffer(2);
        const dv = new DataView(buffer);
        dv.setInt16(0, value);
        this.data.push(dv.getUint8(0));
        this.data.push(dv.getUint8(1));
    }
    WriteBuffer(value) {
        this.WriteAllBytes(value.data);
    }
    WriteAllBytes(value) {
        for (let i = 0; i < value.length; i++) {
            this.data.push(value[i]);
        }
    }
    WriteBoolean(value) {
        this.data.push(value ? 1 : 0);
    }
}
